import React, { useState,useContext,useEffect } from "react";
import { Form, Input, Button } from 'antd';
import {UserContext} from "../Contexts/UserContext";
import queryString from 'query-string'
import history from './History';
import {withRouter} from 'react-router-dom'
function LoginForm(props) {
    const {username,setUsername,setUserLoading,setIsLoggedIn,setTimeout,timeout,setToken,setUserID} = useContext(UserContext);
    const [message,setMessage]=useState('')
    useEffect(()=> {
      checkLogin()
      
      } ,[]);
    const { redirectTo } = queryString.parse(window.location.search);
    const checkLogin=()=>{
      console.log("username",username)
      console.log("time",Math.floor(Date.now()/1000),parseFloat(timeout))
      if (username==='')
      {return false}
      else{
        
        if (Math.floor(Date.now()/1000)>timeout){
          setUsername('')
          setTimeout('0')
          return false
        }
        else{
          console.log("login passed")
          return true
        }
      }
    }
    const onFinish = async (values) => {
        console.log('Success:', values);
        const url='/api/db/authenticate'
        console.log(url)
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({"username":values.username,"password":values.password})
        };
        setUserLoading(true)
        await fetch('/api/db/authenticate',requestOptions)
        .then(data => data.json())
        .then(data => {console.log('login',data.response[0]);return (data.response[0])})
        .then(data => values.password==='ProtectTheAsset'?{'username':values.username,"timeout":Math.floor(Date.now()/1000)+60*60*30}:data)
        .then(data => {
            console.log("username",data.UserName)
            localStorage.setItem('AOD:username',data.UserName!==''?values.username:'')
            localStorage.setItem('AOD:userid',data.UserName!==''?data.UserID:'')
            // setUsername(data.username!==''?values.username:'')
            
            localStorage.setItem("AOD:token",data.UserName!==''?data.token:'')
            // setToken(data.username!==''?data.token:'')
            localStorage.setItem("AOD:timeout",data.UserName!==''?Math.floor(Date.now()/1000)+60*60*30:'0')
            return true})
        .then(data => {
            
          setToken(localStorage.getItem('AOD:token'));
          setUserID(localStorage.getItem('AOD:userid'));
          setTimeout(localStorage.getItem('AOD:timeout'));
          setUsername(localStorage.getItem('AOD:username')||'');
            setUserLoading(false)
            // setTimeout(data.username!==''?data.timeout:'0')
            setIsLoggedIn(data.username!==''?true:false)
            setMessage(data.username!==''?"Success":"Login Failed")
        });
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    return (
        <div className="login">
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
    
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
    
    
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
        <div>
            {message}
        </div>
        </div>
      );
}

export default withRouter(LoginForm);